module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "apc-wrap"
  }, [_c('modal', {
    staticClass: "apc-modal",
    attrs: {
      "name": "assignPromoCode",
      "height": "auto",
      "scrollable": true,
      "adaptive": true,
      "width": "90%",
      "maxWidth": 620
    },
    on: {
      "before-close": _vm.onClose,
      "before-open": _vm.reset
    }
  }, [_c('div', {
    staticClass: "apc-dialog"
  }, [_c('div', {
    staticClass: "apc-dialog-header"
  }, [_c('div', {
    staticClass: "apc-dialog-header-left"
  }, [_c('span', {
    staticClass: "apc-dialog-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "7",
      "y1": "7",
      "x2": "7.01",
      "y2": "7"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "apc-dialog-title"
  }, [_vm._v("Assign Promo Code")]), _vm._v(" "), _c('p', {
    staticClass: "apc-dialog-sub"
  }, [_vm._v("Search for an available promo code and attach it to this runner")])])]), _vm._v(" "), _c('button', {
    staticClass: "apc-close-btn",
    attrs: {
      "type": "button",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('assignPromoCode')
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "18",
      "y1": "6",
      "x2": "6",
      "y2": "18"
    }
  }), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "6",
      "x2": "18",
      "y2": "18"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "apc-dialog-body"
  }, [_c('div', {
    staticClass: "apc-search-container"
  }, [_c('label', {
    staticClass: "apc-label"
  }, [_vm._v("Search Promo Code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "apc-input",
    attrs: {
      "type": "text",
      "placeholder": "Type to search..."
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }, _vm.onSearch]
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "apc-loading"
  }, [_vm._v("Searching...")]) : _vm._e(), _vm._v(" "), (_vm.results.length > 0) ? _c('ul', {
    staticClass: "promo-results"
  }, _vm._l((_vm.results), function(code) {
    return _c('li', {
      key: code.id,
      class: {
        'selected': _vm.selectedCode && _vm.selectedCode.id === code.id
      },
      on: {
        "click": function($event) {
          return _vm.selectCode(code)
        }
      }
    }, [_vm._v("\n                " + _vm._s(code.code) + " \n                "), (code.description) ? _c('span', {
      staticClass: "apc-result-desc"
    }, [_vm._v(_vm._s(code.description))]) : _vm._e()])
  }), 0) : (!_vm.isLoading && _vm.searchQuery.length > 0 && _vm.results.length === 0) ? _c('div', {
    staticClass: "apc-empty"
  }, [_vm._v("\n            No promo codes found.\n         ")]) : _vm._e()]), _vm._v(" "), (_vm.selectedCode) ? _c('div', {
    staticClass: "apc-selected"
  }, [_c('strong', [_vm._v("Selected:")]), _vm._v(" " + _vm._s(_vm.selectedCode.code) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "apc-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "apc-dialog-footer"
  }, [_c('button', {
    staticClass: "apc-cancel-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('assignPromoCode')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "apc-save-btn",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedCode
    },
    on: {
      "click": _vm.assign
    }
  }, [_vm._v("Assign")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0503ab18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/AssignPromoCode.vue
// module id = 1647
// module chunks = 2